import { useEffect, useState } from 'react';
import type { ISession } from '../interface/session';

function useSiteName(userSession: ISession | null): string | null {
    const [siteName, setSiteName] = useState<string | null>(null);

    useEffect(() => {
        if (!userSession) {
            return;
        }
        const updateTranslation = async () => {
            const db = await userSession.db.open();
            const site = await db.first('ISiteDto');
            db.close();
            setSiteName(site.name ?? '');
        };
        updateTranslation().catch(error => {
            throw error;
        });
    }, [userSession, setSiteName]);

    return siteName;
}

export default Object.freeze({
    useSiteName,
});
